export class ActivityViewModel {
  activityUid!: string;
  name!: string;
  apiUrl!: string;
  defaultColor!: string;
  iconCss!: string;
  constructor(data: any) {
    if (data != null) {
      this.activityUid = data.activityUid;
      this.name = data.name;
      this.apiUrl = data.apiUrl;
      this.defaultColor = data.defaultColor;
      this.iconCss = data.iconCss;
    }
  }
}
